import axios from "axios";
import { decrypt } from "utils/security";
import { getToken } from "utils/token";


const verifyCoupon = async (payload: any) => {
    const { data } = await axios.get(`coupons/${payload?.couponId}/${payload?.planId}`, {
        headers: { Authorization: getToken() },
    });

    return decrypt(data?.data);
};

export default verifyCoupon;
